import React from 'react'
import * as FileSaver from 'file-saver';
import * as XLSX from "xlsx";

export const ExportToExcel = ({ apiData, fileName }) => {
	const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension = ".xlsx";

	const exportToCSV = (apiData, fileName) => {
		const ws = XLSX.utils.json_to_sheet(apiData);
		const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
		const data = new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, fileName + fileExtension);
	};

	return (
		<div className="ellipsis" onClick={(e) => {
			e.preventDefault();
			exportToCSV(apiData, fileName);
		}}>
			<button></button> <label id='copyLabel'>Exportar Planilla</label>
		</div>
	);
};


export const ExportToCSV = ({ apiData, fileName }) => {
	const fileType = "text/csv;charset=UTF-8";
	const fileExtension = ".csv";

	if (!apiData || !apiData.length) return null;


	const exportToCSV = (apiData, fileName) => {

		if (!apiData || !apiData.length) return;

		// Encabezados
		const headers = Object.keys(apiData[0]).join(';') + '\n';

		// Filas
		const rows = apiData.map(row =>
			Object.values(row).map(val => {
				// Si es número, reemplaza punto decimal por coma
				if (typeof val === 'number') {
					return val.toString().replace('.', ',');
				}
				// Si es string que representa número decimal, también reemplaza
				if (typeof val === 'string' && /^-?\d+\.\d+$/.test(val)) {
					return val.replace('.', ',');
				}
				// Escapa comillas dobles y punto y coma
				if (typeof val === 'string') {
					return `"${val.replace(/"/g, '""')}"`;
				}
				return val;
			}).join(';')
		).join('\n');

		const csv = headers + rows;
		const blob = new Blob([csv], { type: fileType });
		FileSaver.saveAs(blob, fileName + fileExtension);
	};


	return (
		<div className="ellipsis" onClick={e => {
			e.preventDefault();
			exportToCSV(apiData, fileName);
		}}>
			<button></button> <label id='copyLabel'>Exportar Planilla</label>
		</div>
	);
};